import React from "react";
import Paywall from "./Paywall";
import { usePaywall } from "./paywallContext";

const PaywallHost: React.FC = () => {
  const { isOpen, options, closePaywall } = usePaywall();

  if (!isOpen) return null;

  return (
    <Paywall
      open={isOpen}
      onRequestClose={closePaywall}
      options={options ?? undefined}
    />
  );
};

export default PaywallHost;
